import { reducer as authReducer } from './slice';

export * from './actions';

export default authReducer;
